const SESSION = {
  BOOT: 'BOOT',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  LOGOUT: 'LOGOUT',
  ADD_GAME: 'ADD_GAME',
  ADD_PALA: 'ADD_PALA',
  REMOVE_PALA: 'DELETE_PALA',
  CHANGE_LEVEL: 'CHANGE_LEVEL',
};

const boot = bool => {
  return {
    type: SESSION.BOOT,
    payload: bool,
  };
};

const success = (user, games) => ({
  type: SESSION.SUCCESS,
  payload: { user, games },
});

const fail = error => ({
  type: SESSION.FAIL,
  payload: error,
});
const logOut = _ => ({
  type: SESSION.LOGOUT,
});

const addGame = game => ({
  type: SESSION.ADD_GAME,
  payload: game,
});
const addPala = pala => ({
  type: SESSION.ADD_PALA,
  payload: pala,
});

const removePala = pala => ({
  type: SESSION.REMOVE_PALA,
  payload: pala,
});

const changeLevel = level => ({
  type: SESSION.CHANGE_LEVEL,
  payload: level,
});

export default {
  addGame,
  addPala,
  changeLevel,
  logOut,
  fail,
  success,
  boot,
  removePala,
};

export { sessionReducer };

const initialState = {
  booting: false,
  authed: false,
  error: false,
  notification: {
    msg: undefined,
    id: null,
  },
  user: {},
  games: [],
  lastUpdated: false,
};

function sessionReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SESSION.SUCCESS:
      return {
        ...state,
        authed: true,
        booting: false,
        user: action.payload.user,
        games: action.payload.games,
      };
    case SESSION.ADD_GAME:
      return { ...state, games: [...state.games, action.payload] };
    case SESSION.ADD_PALA:
      return {
        ...state,
        user: { ...state.user, palas: [...state.user.palas, action.payload] },
      };

    case SESSION.REMOVE_PALA:
      return {
        ...state,
        user: { ...state.user, palas: state.user.palas.filter(p=> p.nickname !== action.payload.nickname) },
      };
      
    case SESSION.CHANGE_LEVEL:
      return {
        ...state,
        user: { ...state.user, level: action.payload },
      };
    case SESSION.BOOT:
      return { ...state, booting: action.payload };
    case SESSION.ERROR:
      return { ...state, authed: false, error: true };
    case SESSION.LOGOUT:
      return { ...state, authed: false };
    default:
      return state;
  }
}
